/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// import "katex/dist/katex.css";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $wrapNodeInElement } from "@lexical/utils";
import type { LexicalCommand } from "lexical";
import {
  $createParagraphNode,
  $insertNodes,
  $isRootOrShadowRoot,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  //   LexicalEditor,
} from "lexical";
import React from "react";
import { useEffect } from "react";

import KatexEquationAlterer from "../components/KatexEquationAlterer";
import { $createEquationNode, EquationNode } from "../nodes/EquationNode";

type CommandPayload = {
  equation: string;
  inline: boolean;
};

export const INSERT_EQUATION_COMMAND: LexicalCommand<CommandPayload> =
  createCommand("INSERT_EQUATION_COMMAND");

export function InsertEquationDialog({
  //   activeEditor,
  onEquation,
}: {
  //   activeEditor: LexicalEditor;
  onEquation: (equation: string, inline: boolean) => void;
}): JSX.Element {
  //   const onEquation = useCallback(
  //     (equation: string, inline: boolean) => {
  //       activeEditor.dispatchCommand(INSERT_EQUATION_COMMAND, { equation, inline });
  //       onClose();
  //     },
  //     [activeEditor, onClose],
  //   );

  return <KatexEquationAlterer onEquation={onEquation} />;
}

export default function EquationPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([EquationNode])) {
      throw new Error("EquationsPlugins: EquationsNode not registered on editor");
    }

    return editor.registerCommand<CommandPayload>(
      INSERT_EQUATION_COMMAND,
      payload => {
        const { equation, inline } = payload;
        const equationNode = $createEquationNode(equation, inline);

        $insertNodes([equationNode]);
        if ($isRootOrShadowRoot(equationNode.getParentOrThrow())) {
          $wrapNodeInElement(equationNode, $createParagraphNode).selectEnd();
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
